module.exports = __webpack_public_path__ + "media/images/category-energy-1411e471455ed4ba76e700ea31d01384.jpg";